module.exports = __webpack_public_path__ + "26cafa6fac10b22a85e149df5ec06aca.svg";